export default __webpack_public_path__ + "static/media/cover-leafText1.5fd7a793.png";